module.exports = __webpack_public_path__ + "static/img/accreditation_2024-uk.a38b4b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/accreditation_2024-uk.png
// module id = zCXD
// module chunks = 8